module.exports = __webpack_public_path__ + "img/phoneHaed.eb35fba2.png";